import RoleView from './RoleView';
import UserView from './UserView';
import APIsView from './APIsView';
import UtilsView from './UtilsView';
import AlertView from './AlertView';
import ExportingView from './ExportingView';

import { BrowserRouter as Router, Link, Route, Redirect } from 'react-router-dom';
import React from 'react';
import { Layout, Menu, Button } from 'antd';
import { MenuOutlined, HomeOutlined, IdcardOutlined, AlertOutlined, CodeOutlined, DatabaseOutlined, ApiOutlined } from '@ant-design/icons';

const { Content, Sider } = Layout;

class PermView extends React.Component {

    pathToView = {
        '/admin/roles': 'RoleView',
        '/admin/users': 'UserView',
        '/admin/alert': 'AlertView',
        '/admin/utils': 'UtilsView',
        '/admin/apis': 'APIsView',
        '/admin/exporting': 'ExportingView',
    }

    constructor() {
        super();
        const path = window.location.pathname;
        const view = this.pathToView[path];
        //console.log(view);
        this.state = {
            collapsed: false,
            currentView: view === undefined ? 'UserView' : view
        };
    }

    collapseSider() {
        this.setState({ collapsed: !this.state.collapsed });
    }

    render() {
        return (
            <Router basename="/admin">
                <Layout className="site-layout-background" style={{ padding: '24px 0' }} hidden={this.props.hidden} >
                    <Sider className="site-layout-background" width={200} theme={"light"} collapsed={this.state.collapsed}>
                        <Menu
                            mode="inline"
                            defaultSelectedKeys={[this.state.currentView]}
                            selectedKeys={[this.state.currentView]}
                            onSelect={(item)=>this.setState({currentView: item.key})}
                            style={{ height: '100%' }}
                        >
                            <Button size="middle" icon={<MenuOutlined />} onClick={(e) => this.collapseSider()}
                                style={{
                                    color: "#000000",
                                    border: "none",
                                    margin: "0px 0px 0px 15px"
                                }}
                            />
                            <Menu.Item icon={<HomeOutlined />} key="RoleView">
                                <Link to="/roles">角色管理</Link>
                            </Menu.Item>
                            <Menu.Item icon={<IdcardOutlined />} key="UserView">
                                <Link to="/users">用户管理</Link>
                            </Menu.Item>
                            <Menu.Item icon={<ApiOutlined />} key="APIsView">
                                <Link to="/apis">访问管理</Link>
                            </Menu.Item>
                            <Menu.Item icon={<DatabaseOutlined />} key="ExportingView">
                                <Link to="/exporting">导数工具</Link>
                            </Menu.Item>
                            <Menu.Item icon={<AlertOutlined />} key="AlertView">
                                <Link to="/alert">预警规则</Link>
                            </Menu.Item>
                            <Menu.Item icon={<CodeOutlined />} key="UtilsView">
                                <Link to="/utils">工具箱</Link>
                            </Menu.Item>
                        </Menu>
                    </Sider>
                    <Content justify="space-around" align="middle" style={{ padding: '0 24px', minHeight: 280 }}>
                        <Route path="/roles" exact component={RoleView} />
                        <Route path="/users" exact component={UserView} />
                        <Route path="/apis" exact component={APIsView} />
                        <Route path="/utils" exact component={UtilsView} />
                        <Route path="/alert" exact component={AlertView} />
                        <Route path="/exporting" exact component={ExportingView} />
                        <Route path="/" exact render={()=><Redirect to="/users" />} />
                    </Content>
                </Layout>
            </Router>
        );
    }
}

export default PermView;